import { BaseButton } from 'iebt-zing-storybook'
import React, { useState } from 'react'
import { updateProvider } from 'sharedKernel/api'
import { hasAccess } from 'sharedKernel/auth/behavior'
import { trans } from 'sharedKernel/i18n'
import { showDoubleActionPopUp } from 'components/popup/doubleAction'
import { showToast } from 'components/toast'
import { useSmartNavigateLegacy as useNavigate } from 'components/SmartLink'
import { EventButtonsProps } from '../contract'

export const LaunchEventButton = ({
  eventId,
  isOwner,
  alreadyLaunched
}: EventButtonsProps): JSX.Element => {
  const haveAccess = hasAccess('challenge', 'launch')
  const labels = {
    btnText: 'Publicar',
    launchSuccess: 'Evento publicado com sucesso',
    launchError: 'O evento não pode ser publicado. Verifique os campos marcados de vermelho no formulário'
  }
  const { mutate: persistLaunchEvent } = updateProvider()
  const navigate = useNavigate()

  const launchEvent = async (): Promise<void> => {
    persistLaunchEvent(
      { url: `/v1/hub/company/event/${eventId ?? ''}/launch` },
      {
        onSuccess: () => {
          showToast('success', labels.launchSuccess)
          navigate(`/hub/company/event/${eventId}`, {
            state: { setToLaunched: true }
          })
        },
        onError: () => {
          showToast('error', labels.launchError)
          navigate(`/hub/company/event/${eventId}/edit?validate=launch`, {
            state: { setToLaunched: true }
          })
        }
      }
    )
  }

  const handleLaunchEvent = (): void => {
    showDoubleActionPopUp({
      title: 'Lançar evento',
      message: 'Deseja realmente lançar esse evento?',
      buttons: [{ text: 'Sim' }, { text: 'Não' }],
      action: async () => launchEvent()
    })
  }

  if (!haveAccess || !isOwner || alreadyLaunched) {
    return <></>
  }
  return (
    <>
      <BaseButton
        btnContent={trans(labels.btnText)}
        variant="primary"
        size="medium"
        onClick={() => {
          handleLaunchEvent()
        }}
      />
    </>
  )
}
